import React, { useState, useEffect } from 'react';
import { Card, Typography, Button } from 'antd';
import authService from '../services/authService';
import LeadTestComponent from './LeadTestComponent';
import SimpleLeadDetails from './SimpleLeadDetails';
import LeadDetailsTest from './LeadDetailsTest';

const { Text, Title } = Typography;

export default function DebugInfo() {
  const [user, setUser] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userDetails = await authService.getUserDetails();
        setUser(userDetails);
        console.log('Debug - Current user details:', userDetails);
      } catch (error) {
        console.error('Debug - Error fetching user:', error);
      }
    };

    fetchUser();
  }, []);

  const testNavigation = () => {
    const companyId = user?.company_id || 'test';
    const url = `/companies/${companyId}/lead-reassign`;
    console.log('Testing navigation to:', url);
    window.location.href = url;
  };

  const testLeadDetails = () => {
    const companyId = user?.company_id || 'test';
    const url = `/companies/${companyId}/lead-details`;
    console.log('Testing navigation to lead details:', url);
    window.location.href = url;
  };

  if (!user) return <div>Loading user info...</div>;

  return (
    <>
      <Card 
        title="Debug: User & Menu Info" 
        size="small"
        style={{ margin: '10px 0', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7' }}
        extra={
          <div>
            <Button size="small" onClick={testNavigation} style={{ marginRight: 8 }}>
              Test Lead Reassign
            </Button>
            <Button size="small" onClick={testLeadDetails} style={{ marginRight: 8 }}>
              Test Lead Details
            </Button>
            <Button size="small" onClick={() => setShowDetails(!showDetails)}>
              {showDetails ? 'Hide' : 'Show'} Details
            </Button>
          </div>
        }
      >
        <div style={{ fontSize: '12px' }}>
          <div><Text strong>Name:</Text> {user.name || 'N/A'}</div>
          <div><Text strong>Email:</Text> {user.email || 'N/A'}</div>
          <div><Text strong>Role ID:</Text> <Text code>{user.role_id || 'N/A'}</Text></div>
          <div><Text strong>Role:</Text> <Text code>{user.role || 'N/A'}</Text></div>
          <div><Text strong>Company ID:</Text> <Text code>{user.company_id || 'N/A'}</Text></div>
          <div><Text strong>Current URL:</Text> <Text code>{window.location.pathname}</Text></div>
          
          {showDetails && (
            <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
              <Text strong>Full User Object:</Text>
              <pre style={{ fontSize: '10px', margin: '5px 0' }}>
                {JSON.stringify(user, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </Card>
      
      <LeadDetailsTest />
      
      <SimpleLeadDetails defaultCompanyId={user?.company_id || ''} />
      
      <LeadTestComponent />
    </>
  );
}